import { createHttpEndpoint } from '../../utils'

import type {
  GetListingAlertsResponse,
  GetListingCommentsResponse,
  GetListingMetadata,
  GetListingsFiltersMetadataResponse,
  GetListingsResponse,
  GetPotentialShippingMethodsResponse,
  GetSimilarListingsResponse,
  Listing,
  OldBackboxInfo,
} from './listings.types'

export const getListings = createHttpEndpoint<GetListingsResponse>({
  method: 'GET',
  operationId: 'getListings',
  path: '/api/seller-experience/listings',
})

export const getListing = createHttpEndpoint<Listing>({
  method: 'GET',
  operationId: 'getListing',
  path: '/api/seller-experience/listings/:listingId',
})

/**
 * Retrieve product metadata as an authenticated merchant.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Listings/operation/get-bm-merchants-product-product_id-listings-metadata}
 */
export const getListingMetadata = createHttpEndpoint<GetListingMetadata>({
  method: 'GET',
  operationId: 'getProductMetadata',
  path: '/api/seller-experience/listings/metadata/create/products/:productId',
})

export const createListing = createHttpEndpoint({
  method: 'POST',
  operationId: 'createListing',
  path: '/api/seller-experience/listings',
})

export const getListingsFiltersMetadata =
  createHttpEndpoint<GetListingsFiltersMetadataResponse>({
    method: 'GET',
    operationId: 'getListingsFiltersMetadata',
    path: '/api/seller-experience/listings/metadata/search',
  })

export const getBackboxForMarket = createHttpEndpoint({
  method: 'POST',
  operationId: 'getBackboxForMarket',
  path: '/api/seller-experience/listings/:listingId/get-backbox',
})

export const getAllBackboxesForListing = createHttpEndpoint({
  method: 'POST',
  operationId: 'getAllBackboxesForListing',
  path: '/api/seller-experience/listings/:listingId/get-all-backboxes',
})

export const archiveListing = createHttpEndpoint({
  method: 'POST',
  operationId: 'archiveListing',
  path: '/api/seller-experience/listings/:listingId/archive',
})

export const publishListing = createHttpEndpoint({
  method: 'POST',
  operationId: 'publishListing',
  path: '/api/seller-experience/listings/:listingId/publish',
})

export const getSimilarListings =
  createHttpEndpoint<GetSimilarListingsResponse>({
    method: 'GET',
    operationId: 'getSimilarListings',
    path: '/bm/merchants/listings/:listingId/similar/:productId',
  })

export const getListingComments =
  createHttpEndpoint<GetListingCommentsResponse>({
    method: 'GET',
    operationId: 'getListingComments',
    path: '/bm/merchants/listings/:listingId/comments',
  })

export const addListingComment = createHttpEndpoint({
  method: 'POST',
  operationId: 'addListingComment',
  path: '/bm/merchants/listings/:listingId/comments/:market',
})

export const deleteListingComment = createHttpEndpoint({
  method: 'DELETE',
  operationId: 'deleteListingComment',
  path: '/bm/merchants/listings/:listingId/comments/:market',
})

export const getListingAlerts = createHttpEndpoint<GetListingAlertsResponse>({
  method: 'GET',
  operationId: 'getListingAlerts',
  path: '/api/seller-experience/listings/:listingId/alerts',
})

export const getListingShippingMethods =
  createHttpEndpoint<GetPotentialShippingMethodsResponse>({
    method: 'GET',
    operationId: 'getListingShippingMethods',
    path: '/bm/shipping/listings/:listingId/shippings',
  })

export const addListingShippingMethod = createHttpEndpoint({
  method: 'POST',
  operationId: 'addListingShippingMethod',
  path: '/bm/shipping/listings/:listingId/shippings/:market',
})

export const deleteListingShippingMethod = createHttpEndpoint({
  method: 'DELETE',
  operationId: 'deleteListingShippingMethod',
  path: '/bm/shipping/listings-shipping-methods/:shippingId',
})

export const updateListing = createHttpEndpoint({
  method: 'PATCH',
  operationId: 'updateListing',
  path: '/api/seller-experience/listings/:listingId',
})

export const getOldBackboxInfo = createHttpEndpoint<OldBackboxInfo>({
  method: 'GET',
  operationId: 'getOldBackboxInfo',
  path: '/bm/buybox/listings/:listingId',
})

export const setSalesMaximizerPrice = createHttpEndpoint({
  method: 'POST',
  operationId: 'setSalesMaximizerPrice',
  path: '/api/seller-experience/listings/:listingId/set-sales-maximizer-price',
})
